// extracted by mini-css-extract-plugin
module.exports = {"hero":"HomeHero_hero__Xut9g"};